import { Component, EventEmitter, OnDestroy, OnInit, Output, ChangeDetectorRef, inject, DestroyRef, ChangeDetectionStrategy } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Subscription } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BasketPostService } from '../basket-post/basket-post.service';
import { GlobalService } from '../../../global/services/global.service';
import { WorkspaceService } from '../../../workspace/workspace.service';
import { AppService } from '../../../app.service';
import {
  extractObject,
  generalConfigFromGlobal,
  gridPayloadFromActiveScreen,
  hydratedGlobalParams,
  rowPayloadFromActiveScreen,
} from '../../../shared/workspace-element-context';

@Component({
    selector: 'gtw-basket-post-delete',
    templateUrl: './basket-post-delete.component.html',
    styleUrls: ['./basket-post-delete.component.scss'],
    standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class BasketPostDeleteComponent implements OnInit, OnDestroy {
  private readonly destroyRef = inject(DestroyRef);

  @Output('request-grid-update') requestGridUpdate = new EventEmitter<any>();

  private readonly subs = new Subscription();

  currentTabName = "Form Entry";
  minimise = false;
  isSaveClicked = false;
  crudLoading = false;
  showFormLoader = false;

  modalTitle = "Delete basket post 960 map";
  isDelete = true;

  rowData: any = {};
  globalService: any = {};
  GENERAL_CONFIG: any = {};
  USER_SETTINGS: any = {};
  colData: any = {};
  gridData: any = {};

  entityList: any[] = [];
  leId: string = '';
  cdr_no: string = '';
  leType: string = '';

  ho_leid: string = '';
  ho_cdr_no: string = '';
  ho_combination_key: string = '';
  logged_in_user: string = '';

  constructor(
    private _snackBar: MatSnackBar,
    private basketPostService: BasketPostService,
    private cdr: ChangeDetectorRef,
    private gtwGlobal: GlobalService,
    private gtwWorkspace: WorkspaceService,
    private gtwApp: AppService,
  ) {}

  ngOnInit(): void {
    this.applyWorkspaceContext();
    this.init();
    this.subs.add(this.gtwWorkspace.setTabActive.subscribe(() => this.applyWorkspaceContext()));
    this.subs.add(this.gtwGlobal.globalParamsChanged$.subscribe(() => this.applyWorkspaceContext()));
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  private applyWorkspaceContext(): void {
    const activeScreen = this.gtwWorkspace.workspaceFactory?.activeScreen || {};
    const activeData: any = activeScreen?.data || {};
    this.GENERAL_CONFIG = generalConfigFromGlobal(this.gtwGlobal);
    this.globalService = hydratedGlobalParams(this.gtwGlobal, this.gtwWorkspace);
    this.USER_SETTINGS = this.gtwApp.USER_SETTINGS || {};
    this.logged_in_user = this.USER_SETTINGS?.user?.sso_id || '';
    this.rowData = rowPayloadFromActiveScreen(activeScreen);
    this.colData = extractObject(activeData?.colData || activeData?.col_data || {});
    const gd = gridPayloadFromActiveScreen(activeScreen);
    this.gridData = gd != null ? gd : {};
    this.cdr.markForCheck();
  }

  init() {
    try {
      if (this.rowData && Object.keys(this.rowData).length > 0) {
        this.setupEntityData();
        this.processRowData();
      }
    } catch (e) {
      console.error('Error in BasketPostDelete init:', e);
    }
  }

  private setupEntityData() {
    this.leId = this.rowData.LEID || '';
    this.cdr_no = this.rowData.MARS || '';
    this.leType = this.rowData.LE_TYPE || '';

    this.entityList = [
      { key: "Tax Year", value: this.rowData.TAX_YEAR || '' },
      { key: "LEID", value: this.rowData.LEID || '' },
      { key: "LE Name", value: this.rowData.LE_NAME || '' }
    ];
  }

  private processRowData() {
    if (this.rowData) {
      this.ho_leid = this.rowData.HO_LEID || '';
      this.ho_cdr_no = this.rowData.HO_CDR_NO || '';
      this.ho_combination_key = this.rowData.HO_COMBINATION_KEY || '';
    }
  }

  deletePayment() {
    this.isSaveClicked = true;
    this.crudLoading = true;

    const clob_settings = [{
      sso_id: this.logged_in_user,
      screen_key: this.globalService?.screen_key || ''
    }];

    const success_message = "Basket post 960 map deleted successfully.";

    this.basketPostService.deleteBasketPost(
      this.GENERAL_CONFIG.base_url,
      this.rowData,
      clob_settings,
      this.logged_in_user,
      this.globalService,
      {}
    ).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      (response: any) => {
        this.isSaveClicked = false;
        this.crudLoading = false;

        if (response.errorMessage && response.errorMessage !== 'null') {
          this._snackBar.open(response.errorMessage, 'Close', {
            duration: 4000,
            panelClass: ['error-snackbar']
          });
        } else {
          this._snackBar.open(success_message, 'Close', {
            duration: 4000,
            panelClass: ['success-snackbar']
          });
          this.requestGridUpdate.emit('refresh');
        }
      },
      (error: any) => {
        this.isSaveClicked = false;
        this.crudLoading = false;
        this._snackBar.open('Error occurred while deleting. Please try again.', 'Close', {
          duration: 4000,
          panelClass: ['error-snackbar']
        });
      }
    );
  }

  cancel() {
    this.requestGridUpdate.emit('cancel');
  }
}
